import { useRef, useState } from "react";
import { Upload, X } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const inputCls =
  "w-full border border-white/15 bg-transparent px-3 py-2 text-sm text-white placeholder-white/30 outline-none transition-colors duration-300 focus:border-[#D4AF37]";

export const ImageField = ({ value, onChange, testid }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail, "Upload failed"));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div data-testid={testid}>
      <div className="flex gap-2">
        <input
          className={inputCls}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Image URL, or upload a file"
          data-testid={`${testid}-input`}
        />
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          data-testid={`${testid}-upload-button`}
          className="flex shrink-0 items-center gap-2 border border-[#D4AF37]/60 px-4 text-[10px] uppercase tracking-[0.2em] text-[#D4AF37] transition-colors duration-300 hover:bg-[#D4AF37] hover:text-black disabled:opacity-40"
        >
          <Upload className="h-3.5 w-3.5" /> {busy ? "…" : "Upload"}
        </button>
        <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={upload} data-testid={`${testid}-file-input`} />
      </div>
      {value ? (
        <div className="relative mt-3 w-32">
          <img src={value} alt="preview" className="aspect-[3/4] w-32 border border-white/15 object-cover" data-testid={`${testid}-preview`} />
          <button
            type="button"
            aria-label="Clear image"
            onClick={() => onChange("")}
            data-testid={`${testid}-clear`}
            className="absolute -right-2 -top-2 border border-white/20 bg-[#0A0A0B] p-1 text-white/60 transition-colors hover:border-[#D4AF37] hover:text-[#D4AF37]"
          >
            <X className="h-3 w-3" />
          </button>
        </div>
      ) : (
        <p className="mt-2 text-[10px] uppercase tracking-[0.2em] text-white/30">Empty = gold thread placeholder</p>
      )}
    </div>
  );
};

export default ImageField;
